var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1729 9.36697C21.6975 9.60865 22.1636 9.96107 22.539 10.4C22.9137 10.8372 23.1897 11.3502 23.3479 11.9038C23.5062 12.4575 23.5431 13.0388 23.456 13.608L22.38 20.608C22.2389 21.5543 21.7615 22.4181 21.0353 23.041C20.3091 23.664 19.3828 24.0045 18.426 24H6V11L9.035 0.737C9.09271 0.525297 9.21845 0.338452 9.39283 0.205268C9.56722 0.0720843 9.78057 -4.47569e-05 10 2.08359e-08C12.206 2.08359e-08 13 1.794 13 4V9H19.5C20.0776 9.00011 20.6483 9.1253 21.1729 9.36697ZM1 11H4V24H1C0.734784 24 0.48043 23.8946 0.292893 23.7071C0.105357 23.5196 0 23.2652 0 23V12C0 11.7348 0.105357 11.4804 0.292893 11.2929C0.48043 11.1054 0.734784 11 1 11Z",
    fill: "#2BECC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.3b6aecbfcb073ef64faacf5a75b8ab5d.svg";
export { ForwardRef as ReactComponent };